const DURATION_UNIT = ["Days", "Months", "Years"];

export default DURATION_UNIT;
